<template>
  <section class="form-list">
    <div v-show="isLoading || isSaving || isLoadingError" class="loading-box">
      <div class="loading-main" @click="load">
        <svg v-show="isLoading || isSaving" class="loading-circular" viewBox="25 25 50 50">
          <circle class="loading-path" cx="50" cy="50" r="20" fill="none"/>
        </svg>
        <div v-show="isLoadingError" class="loading-refresh">
          <i class="el-icon-refresh"/>
        </div>
        <div v-show="isLoadingError" class="loading-text">
          数据加载失败，点击重新尝试
        </div>
      </div>
    </div>

    <el-form
      class="form form-max"
      ref="form"
      :model="report"
      label-position="left"
      label-width="160px"
    >
      <el-form-item v-if="isAdministrator" label="所属门店">
        {{ report.store_name }}
      </el-form-item>
      <el-form-item label="所属月份">
        {{ getYearAndMonth(report.report_date) }}
      </el-form-item>
      <el-form-item label="添加时间">{{ report.add_time | timeToYmdHi }}</el-form-item>

      <div class="alert-box">
        <div class="alert-item">
          本月共收入 <b>{{ report.all_income }}</b> 元，
          支出 <b>{{ report.expenditure }}</b> 元，
          盈利 <b>{{ report.profit }}</b> 元。
          <template v-if="report.is_ladder_salary">
            共上专业班 <b>{{ report.major_course_count }}</b> 小时，
            成人 <b>{{ report.adult_course_count }}</b> 小时，
            少儿 <b>{{ report.child_course_count }}</b> 小时，
          </template>
          <template v-else>
            共上大课 <b>{{ report.group_course_count }}</b> 小时，
          </template>
          私教 <b>{{ report.private_course_count }}</b> 小时，
          请假代课 <b>{{ report.absence_count }}</b> 小时，
          迟到 <b>{{ report.late_count }}</b> 小时。
          <template v-if="report.total_attendance">
            大课课时总人次 <b>{{ report.total_attendance | toYuan }}</b>（由日总结提供），
          </template>
          每课时平均人数 <b>{{ report.average_attendance | toYuan }}</b> 人。
          <template v-if="report.student_count">共计上课学员 <b>{{ report.student_count }}</b> 人次。</template>
        </div>
        <div class="alert-item">
          上月环比：
          <template v-if="report.last_month_income_is_zero">
            上月总收入为 0 元，
            <span :class="`${report.last_month_income_absolute_increase >= 0 ? 'danger' : 'success'}-color`">本月绝对增量为 {{ report.last_month_income_absolute_increase }} 元</span>，
          </template>
          <template v-else>
            <span v-if="report.last_month_income_trend_percent > 0" class="danger-color">总收入增长 {{ report.last_month_income_trend_percent}} %</span>
            <span v-else-if="report.last_month_income_trend_percent === 0">总收入无变化</span>
            <span v-else class="success-color">总收入下降 {{ -report.last_month_income_trend_percent }} %</span>，
          </template>

          <span v-if="report.last_month_student_trend > 0" class="danger-color">每课时平均人数增长 {{ report.last_month_student_trend | toYuan }} 人</span>
          <span v-else-if="report.last_month_student_trend === 0">每课时平均人数无变化</span>
          <span v-else class="success-color">每课时平均人数下降 {{ -report.last_month_student_trend | toYuan }} 人</span>，

          <template v-if="report.last_month_profit_is_zero">
            上月总利润为 0 元，
            <span :class="`${report.last_month_profit_absolute_increase >= 0 ? 'danger' : 'success'}-color`">本月绝对增量为 {{ report.last_month_profit_absolute_increase }} 元</span>，
          </template>
          <template v-else>
            <span v-if="report.last_month_profit_trend_percent > 0" class="danger-color">总利润增长 {{ report.last_month_profit_trend_percent}} %</span>
            <span v-else-if="report.last_month_profit_trend_percent === 0">总利润无变化</span>
            <span v-else class="success-color">总利润下降 {{ -report.last_month_profit_trend_percent }} %</span>
          </template>
        </div>
        <div class="alert-item">
          去年同比：
          <template v-if="report.last_year_income_is_zero">
            去年同月总收入为 0 元，
            <span :class="`${report.last_year_income_absolute_increase >= 0 ? 'danger' : 'success'}-color`">本月绝对增量为 {{ report.last_year_income_absolute_increase }} 元</span>，
          </template>
          <template v-else>
            <span v-if="report.last_year_income_trend_percent > 0" class="danger-color">总收入增长 {{ report.last_year_income_trend_percent}} %</span>
            <span v-else-if="report.last_year_income_trend_percent === 0">总收入无变化</span>
            <span v-else class="success-color">总收入下降 {{ -report.last_year_income_trend_percent }} %</span>，
          </template>

          <span v-if="report.last_year_student_trend > 0" class="danger-color">每课时平均人数增长 {{ report.last_year_student_trend  | toYuan }} 人</span>
          <span v-else-if="report.last_year_student_trend === 0">每课时平均人数无变化</span>
          <span v-else class="success-color">每课时平均人数下降 {{ -report.last_year_student_trend  | toYuan }} 人</span>，

          <template v-if="report.last_year_profit_is_zero">
            去年同月总利润为 0 元，
            <span :class="`${report.last_year_profit_absolute_increase >= 0 ? 'danger' : 'success'}-color`">本月绝对增量为 {{ report.last_year_profit_absolute_increase }} 元</span>，
          </template>
          <template v-else>
            <span v-if="report.last_year_profit_trend_percent > 0" class="danger-color">总利润增长 {{ report.last_year_profit_trend_percent}} %</span>
            <span v-else-if="report.last_year_profit_trend_percent === 0">总利润无变化</span>
            <span v-else class="success-color">总利润下降 {{ -report.last_year_profit_trend_percent }} %</span>
          </template>
        </div>
      </div>

      <div v-if="report.new_count || report.commission || report.tax_amount_pay || report.you_zan_income" class="alert-box success-alert">
        <div v-if="report.new_count || report.old_count" class="alert-item">
          本月您须向总部提交
          <template v-if="report.new_count"><b>{{ report.new_count }}</b> 张新生办卡单，</template>
          <template v-if="report.old_count"><b>{{ report.old_count }}</b> 张老生办卡单。</template>所有单号必须顺序相连，并且单号必须与会员卡号一一对应。
        </div>
        <div v-if="report.commission || report.tax_amount_pay" class="alert-item">
          <template v-if="report.commission">
            本月您的店面收入流水总额为 <b>{{ report.all_income }}</b> 元，
            流水提成为 <b>{{ report.commission }}</b> 元{{ report.tax_amount_pay ? '，' : '。' }}
          </template>
          {{ report.commission ? '' : '本月' }}共申请发票 <b> {{ report.invoice_count }} </b> 张，发票总税额为 <b>{{ report.tax_amount_pay }}</b> 元。
          社保总金额为 <b>{{ totalInsurance }}</b> 元，总计 <b>{{ totalInsuranceAndTax }}</b> 元。
        </div>

        <div class="alert-item">
          请在本月 10 日前，转账 <b>{{ plus(totalInsuranceAndTax, report.commission) }}</b> 元至总部支付宝账号：rouwan316@gmail.com（李秋蕊）
        </div>

        <div v-if="report.you_zan_income || report.transfer_income" class="alert-item">
          本月您店的有赞报名为 <b>{{ report.you_zan_income }}</b> 元。
          总部会在 15 日前将
          <b>{{ report.you_zan_income }} x 99 % = {{ youZanIncomeToStore }}</b>
          元有赞收入
          <template v-if="report.transfer_income">
            、<b>{{ report.transfer_income }}</b> 元总部银行帐号收入
          </template>
          <template v-if="report.you_zan_income && report.transfer_income">
            ，总计 <b>{{ plus(youZanIncomeToStore, report.transfer_income)  }}</b> 元
          </template>
          转入您店的账号。
        </div>
      </div>

      <div class="table-box">
        <div v-if="newCards.length" class="table-title table-title-hover" @click="() => isShowNewCards = !isShowNewCards">
          新生收入统计
          <span class="list-count">{{ newCards.length }}</span>
          <template v-if="new_cards_del_count">（包含 <span class="list-count">{{ new_cards_del_count }}</span> 笔退卡 ）</template>
          <div :class="`arrow-box ${isShowNewCards ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          新生收入统计
          <span class="list-count">{{ newCards.length }}</span>
          <template v-if="new_cards_del_count">（包含 <span class="list-count">{{ new_cards_del_count }}</span> 笔退卡 ）</template>
        </div>
        <el-table
          v-show="isShowNewCards"
          :data="newCards"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
          :row-class-name="tableRowClassName"
        >
          <v-column-time value="录入时间" sortable="" align="center"/>
          <v-column-time value="办卡日期" field="register_time" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="课卡 ID" align="center" width="80">
            <template v-slot="{ row }">{{ row.id }}</template>
          </el-table-column>
          <v-column-student label="所属学员" link-page-id="student_id" align="center"/>
          <el-table-column label="课卡名称" align="center" prop="card_name"/>
          <el-table-column label="收入金额" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.actual_payment | toYuan }}</span>
              <span v-if="row.is_del" class="danger-color">（已退卡）</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="oldCards.length" class="table-title table-title-hover" @click="() => isShowOldCards = !isShowOldCards">
          老生收入统计
          <span class="list-count">{{ oldCards.length }}</span>
          <template v-if="old_cards_del_count">（包含 <span class="list-count">{{ old_cards_del_count }}</span> 笔退卡 ）</template>
          <div v-if="oldCards.length" :class="`arrow-box ${isShowOldCards ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          老生收入统计
          <span class="list-count">{{ oldCards.length }}</span>
          <template v-if="old_cards_del_count">（包含 <span class="list-count">{{ old_cards_del_count }}</span> 笔退卡 ）</template>
        </div>
        <el-table
          v-show="isShowOldCards"
          :data="oldCards"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
          :row-class-name="tableRowClassName"
        >
          <v-column-time value="录入时间" sortable="" align="center"/>
          <v-column-time value="办卡日期" field="register_time" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="课卡 ID" align="center" width="80">
            <template v-slot="{ row }">{{ row.id }}</template>
          </el-table-column>
          <v-column-student label="所属学员" link-page-id="student_id" align="center"/>
          <el-table-column label="课卡名称" align="center" prop="card_name"/>
          <el-table-column label="收入金额" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.actual_payment | toYuan }}</span>
              <span v-if="row.is_del" class="danger-color">（已退卡）</span>
            </template>
          </el-table-column>

        </el-table>
      </div>

      <div class="table-box">
        <div v-if="otherIncomes.length" class="table-title table-title-hover" @click="() => isShowOtherIncomes = !isShowOtherIncomes">
          其他收入统计
          <span class="list-count">{{ otherIncomes.length }}</span>
          <div v-if="otherIncomes.length" :class="`arrow-box ${isShowOtherIncomes ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          其他收入统计
          <span class="list-count">{{ otherIncomes.length }}</span>
        </div>
        <el-table
          v-show="isShowOtherIncomes"
          :data="otherIncomes"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="录入时间" sortable="" align="center"/>
          <v-column-time value="收入日期" field="report_date" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="收入名称" align="center" prop="title"/>
          <el-table-column label="收款方式" align="center">
            <template v-slot="{ row }">
              <span>{{ findPaymentModeName(row.card_payment_mode_id) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="收入金额" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.actual_payment | toYuan }}</span>
            </template>
          </el-table-column>

        </el-table>
      </div>

      <div class="table-box">
        <div v-if="updateIncomes.length" class="table-title table-title-hover" @click="() => isShowUpdateIncomes = !isShowUpdateIncomes">
          修改课卡补差价收入统计
          <span class="list-count">{{ updateIncomes.length }}</span>
          <div v-if="updateIncomes.length" :class="`arrow-box ${isShowUpdateIncomes ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          修改课卡补差价收入统计
          <span class="list-count">{{ updateIncomes.length }}</span>
        </div>
        <el-table
          v-show="isShowUpdateIncomes"
          border
          fit
          highlight-current-row
          :data="updateIncomes"
          class="del-card-table store-income-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="审核时间" fixed="left" align="center"/>
          <v-column-admin align="center" label="审核人"/>
          <v-column-avatar align="center" label="申请人" avatarKey="apply_administrator_avatar" nicknameKey="apply_administrator_nickname"/>
          <v-column-student link-page-id="student_id" align="center" label="课卡所属学员"/>
          <el-table-column label="补差价收入" align="center" prop="update_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ row.update_payment | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="补差价收款方式" align="center">
            <template v-slot="{ row }">
              <span>{{ findPaymentModeName(row.update_payment_mode) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="reservationIncomes.length" class="table-title table-title-hover" @click="() => isShowReservationIncomes = !isShowReservationIncomes">
          小程序预约收入统计
          <span class="list-count">{{ reservationIncomes.length }}</span>
          <template v-if="reservation_income_del_count">（包含 <span class="list-count">{{ reservation_income_del_count }}</span> 笔退款 ）</template>
          <div :class="`arrow-box ${isShowReservationIncomes ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          小程序预约收入统计
          <span class="list-count">{{ reservationIncomes.length }}</span>
          <template v-if="reservation_income_del_count">（包含 <span class="list-count">{{ reservation_income_del_count }}</span> 笔退款 ）</template>
        </div>
        <el-table
          v-show="isShowReservationIncomes"
          :data="reservationIncomes"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
          :row-class-name="reservationIncomeTableRowClassName"
        >
          <v-column-time field="success_time_int" value="支付时间" fixed="left" align="center"/>
          <el-table-column label="订单总金额" align="center" prop="total" type="money">
            <template v-slot="{ row }">
              <span>{{ row.total | toYuan }}</span>
              <span v-if="row.is_refund" class="danger-color">（已申请退款）</span>
            </template>
          </el-table-column>
          <v-column-student link-page-id="student_id" align="center" label="下单学员"/>
          <el-table-column label="微信支付订单号" align="center" prop="transaction_id" type="isNotSummary"/>
          <el-table-column label="预约课程/专栏" align="center">
            <template v-slot="{ row }">
              <router-link
                v-if="row.course_id"
                class="primary-color"
                :to="RouteConfig.courseManage.to(row.course_id)"
              >{{ row.course_name }}</router-link>
              <router-link
                v-else
                class="primary-color"
                :to="RouteConfig.courseColumnManage.to(row.course_column_id)"
              >{{ row.course_column_name }}</router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="delCards.length" class="table-title table-title-hover" @click="() => isShowDelCards = !isShowDelCards">
          退卡统计
          <span class="list-count-pay">{{ delCards.length }}</span>
          <div v-if="delCards.length" :class="`arrow-box ${isShowDelCards ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          退卡统计
          <span class="list-count-pay">{{ delCards.length }}</span>
        </div>
        <el-table
          v-show="isShowDelCards"
          :data="delCards"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="退卡时间" align="center"/>

          <v-column-admin label="退卡管理员" align="center"/>
          <el-table-column label="退卡原因" prop="del_remark" align="center"/>

          <el-table-column label="退款金额" align="center" prop="del_payment" type="money">
            <template v-slot="{ row }">
              {{ row.del_payment | toYuan }}
            </template>
          </el-table-column>

          <el-table-column label="原因截图" align="center">
            <template v-slot="{ row }">
              <el-image
                v-if="row.del_cover"
                :src="row.del_cover"
                style="width: 60px;height: 60px;"
                fit="cover"
              />
            </template>
          </el-table-column>

          <v-column-student label="所属学员" link-page-id="student_id" align="center"/>
          <el-table-column label="课卡名称" prop="card_name" align="center"/>
          <v-column-time value="办卡日期" field="register_time" time-format="timeToYmd" sortable="" align="center"/>
          <el-table-column label="有效次数" align="center">
            <template v-slot="{ row }">
              {{ row.expire_number | toYuan }}
            </template>
          </el-table-column>
          <el-table-column label="有效日期" align="center">
            <template v-slot="{ row }">
              {{ row.expire_time | timeToYmd }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="report.update_pay_count" class="table-title table-title-hover" @click="() => isShowUpdatePays = !isShowUpdatePays">
          修改课卡补差价支出统计
          <span class="list-count">{{ report.update_pay_count }}</span>
          <div v-if="report.update_pay_count" :class="`arrow-box ${isShowUpdatePays ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          修改课卡补差价支出统计
          <span class="list-count-pay">{{ report.update_pay_count }}</span>
        </div>
        <el-table
          v-show="isShowUpdatePays"
          :data="updatePays"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="审核时间" fixed="left" align="center"/>
          <v-column-admin align="center" label="审核人"/>
          <v-column-avatar align="center" label="申请人" avatarKey="apply_administrator_avatar" nicknameKey="apply_administrator_nickname"/>
          <v-column-student link-page-id="student_id" align="center" label="课卡所属学员"/>
          <el-table-column label="补差价支出" align="center" prop="update_payment" type="money">
            <template v-slot="{ row }">
              <span>{{ -row.update_payment | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="补差价支付方式" align="center">
            <template v-slot="{ row }">
              <span>{{ findPaymentModeName(row.update_payment_mode) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="report.reservation_pay_count" class="table-title table-title-hover" @click="() => isShowReservationPays = !isShowReservationPays">
          小程序预约退款支出统计
          <span class="list-count">{{ report.reservation_pay_count }}</span>
          <div v-if="report.reservation_pay_count" :class="`arrow-box ${isShowReservationPays ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          小程序预约退款支出统计
          <span class="list-count-pay">{{ report.reservation_pay_count }}</span>
        </div>
        <el-table
          v-show="isShowReservationPays"
          :data="reservationPays"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="退款时间" field="success_time_int" fixed="left" align="center"/>
          <v-column-student label="退款学员" link-page-id="student_id" align="center"/>
          <el-table-column label="微信支付订单号" align="center" prop="transaction_id" type="isNotSummary"/>
          <el-table-column label="订单总金额" align="center">
            <template v-slot="{ row }">
              <span>{{ row.total | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退款金额" align="center" prop="payer_refund" type="money">
            <template v-slot="{ row }">
              <span class="pay-count">{{ row.payer_refund | toYuan }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退款课程/专栏" align="center">
            <template v-slot="{ row }">
              <router-link
                v-if="row.course_id"
                class="primary-color"
                :to="RouteConfig.courseManage.to(row.course_id)"
              >{{ row.course_name }}</router-link>
              <router-link
                v-else
                class="primary-color"
                :to="RouteConfig.courseColumnManage.to(row.course_column_id)"
              >{{ row.course_column_name }}</router-link>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <div v-if="report.invoice_count" class="table-title table-title-hover" @click="() => isShowInvoices = !isShowInvoices">
          发票统计
          <span class="list-count-pay">{{ report.invoice_count }}</span>
          <div v-if="report.invoice_count" :class="`arrow-box ${isShowInvoices ? 'arrow-box-active' : ''}`">
            <i class="icon-b-arrow"></i>
          </div>
        </div>
        <div v-else class="table-title">
          发票统计
          <span class="list-count-pay">{{ report.invoice_count }}</span>
        </div>
        <el-table
          v-if="isShowInvoices"
          :data="invoices"
          border
          fit
          highlight-current-row
          class="del-card-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-time value="申请时间" sortable="" align="center"/>
          <v-column-avatar label="申请人员" avatar-key="admin_avatar" nickname-key="admin_nickname" align="center"/>
          <el-table-column label="课卡 ID" width="150" align="center">
            <template v-slot="{ row }">
              {{ row.card_id }}
            </template>
          </el-table-column>
          <el-table-column label="发票对象类型" width="150" prop="updateState" align="center">
            <template v-slot="{ row }">
              {{ row.is_personal ? '个人' : '公司'}}
            </template>
          </el-table-column>
          <el-table-column label="发票对象名称" width="150" prop="invoice_name" align="center"/>
          <el-table-column label="开票金额" width="150" prop="amount" type="money" align="center">
            <template v-slot="{ row }">
              {{ row.amount | toYuan }}
            </template>
          </el-table-column>
          <el-table-column label="税额" prop="tax_amount" type="money" align="center">
            <template v-slot="{ row }">
              {{ row.tax_amount | toYuan }}
            </template>
          </el-table-column>

        </el-table>
      </div>

      <div class="table-box">
        <h3>收入统计</h3>

        <div class="flex">
          <el-form-item label="新生收入笔数" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.new_count }}</span> 笔
          </el-form-item>
          <el-form-item label="新生收入金额" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.new_income }}</span> 元
          </el-form-item>
        </div>

        <div class="flex">
          <el-form-item label="老生收入笔数" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.old_count }}</span> 笔
          </el-form-item>
          <el-form-item label="老生收入金额" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.old_income }}</span> 元
          </el-form-item>
        </div>

        <div class="flex">
          <el-form-item label="试课收入笔数" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.trial_count }}</span> 笔
          </el-form-item>
          <el-form-item label="试课收入金额" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.trial_income }}</span> 元
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="课次券收入笔数" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.card_ticket_income_count }}</span> 笔
          </el-form-item>
          <el-form-item label="课次券收入金额" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.card_ticket_income }}</span> 元
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="购买代金券收入笔数" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.voucher_income_count }}</span> 笔
          </el-form-item>
          <el-form-item label="购买代金券收入金额" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.voucher_income }}</span> 元
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="修改课卡补差价收入笔数" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.update_income_count }}</span> 笔
          </el-form-item>
          <el-form-item label="修改课卡补差价收入金额" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.update_income }}</span> 元
          </el-form-item>
        </div>

        <div class="flex-wrap">
          <el-form-item label="小程序预约收入笔数" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.reservation_income_count }}</span> 笔
          </el-form-item>
          <el-form-item label="小程序预约收入金额" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.reservation_income }}</span> 元
          </el-form-item>
        </div>

        <div class="flex">
          <el-form-item label="其他收入笔数" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.other_count }}</span> 笔
          </el-form-item>
          <el-form-item label="其他收入金额" label-width="110px" class="income-item">
            <span class="danger-color money">{{ report.other_income }}</span> 元
          </el-form-item>
        </div>

        <el-form-item label="其他收入备注" label-width="110px" class="income-item">
          {{ report.other_income_remark || '-' }}
        </el-form-item>

        <div class="flex-wrap">
          <el-form-item label="总收入" label-width="180px" class="income-item">
            <span class="danger-color money">{{ report.all_income }}</span> 元
          </el-form-item>
        </div>
      </div>

      <div class="table-box">
        <h3>收款方式统计</h3>
        <el-form-item label="门店微信账号" label-width="124px">
          <span class="danger-color money">{{ report.we_chat_income }}</span> 元
        </el-form-item>
        <el-form-item label="门店支付宝账号" label-width="124px">
          <span class="danger-color money">{{ report.alipay_income }}</span> 元
        </el-form-item>
        <el-form-item label="门店富掌柜账号" label-width="124px">
          <span class="danger-color money">{{ report.fu_zhang_gui_income }}</span> 元
        </el-form-item>
        <el-form-item label="门店美团账号" label-width="124px">
          <span class="danger-color money">{{ report.meituan_income }}</span> 元
        </el-form-item>
        <el-form-item label="门店银行账号" label-width="124px">
          <span class="danger-color money">{{ report.card_income }}</span> 元
        </el-form-item>
        <el-form-item label="现金" label-width="124px">
          <span class="danger-color money">{{ report.cash_income }}</span> 元
        </el-form-item>
        <el-form-item label="总部有赞账号" label-width="124px">
          <span class="danger-color money">{{ report.you_zan_income }}</span> 元
        </el-form-item>
        <el-form-item label="总部抖音账号" label-width="124px">
          <span class="danger-color money">{{ report.dou_yin_income }}</span> 元
        </el-form-item>
        <el-form-item label="总部银行账号" label-width="124px">
          <span class="danger-color money">{{ report.transfer_income }}</span> 元
        </el-form-item>
        <el-form-item label="总部小程序账号" label-width="124px">
          <span class="danger-color money">{{ report.applet_income }}</span> 元
        </el-form-item>
        <el-form-item label="总收入" label-width="124px">
          <span class="danger-color money">{{ report.all_income_way }}</span> 元
        </el-form-item>
        <el-form-item label="总课消" label-width="124px">
          <span class="danger-color money">{{ report.course_consumption | toYuan }}</span> 元
        </el-form-item>
        <el-form-item label="未消费预付款" label-width="124px">
          <span class="accent-color money">{{ report.not_consumed_amount | toYuan }}</span> 元
          <span class="hint-color">（月末预收余额，不计入本月收支）</span>
        </el-form-item>
      </div>

      <div class="table-box">
        <h3>有赞支付统计</h3>

        <el-table
          :data="youZanIncomes"
          border
          fit
          highlight-current-row
          class="you-zan-table"
          :show-summary="true"
          :summary-method="getTableSummaries"
        >
          <v-column-student link-page-id="student_id"/>
          <v-column-time value="使用时间" field="register_time" sortable=""/>
          <el-table-column label="有赞码券" align="center" prop="you_zan_number" type="isNotSummary"/>
          <el-table-column label="实际付款" align="center" prop="actual_payment" type="money">
            <template v-slot="{ row }">
              {{ row.actual_payment | toYuan }}
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <h3>老师工资统计</h3>

        <el-dialog title="老师工资总计" :visible.sync="isShowCourseDialog" class="teacher-dialog">
          <el-table
            :data="courses"
            border
            fit
            highlight-current-row
            :show-summary="true"
            :summary-method="getTeacherSummaries"
          >
            <el-table-column label="序号" align="center" width="130">
              <template v-slot="{ $index, row }">
                {{ $index + 1 }}
              </template>
            </el-table-column>
            <el-table-column label="课程时间" align="center" width="260" type="isNotSummary">
              <template v-slot="{ row }">{{ row.start_time | timeToYmdHi }}{{ ' - '}}{{ row.end_time | timeToHi }}</template>
            </el-table-column>
            <el-table-column label="课程时长" align="center" width="120" prop="duration" type="money">
              <template v-slot="{ row }">
                {{ row.duration | toYuan }}
              </template>
            </el-table-column>
            <el-table-column label="课程类型" align="center" prop="card_type_name"/>
            <el-table-column label="课程名称" align="center" prop="course_name"/>
            <el-table-column label="预约人数" align="center" prop="student_count"/>
            <el-table-column label="出勤状态" align="center">
              <template v-slot="{ row }">
                <el-tag
                  v-for="v in findCourseState(row.course_state)"
                  :key="`courseStateSub${v.name}`"
                  :type="v.tagType"
                >
                  {{ v.name }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="代课老师" align="center" prop="nickname" type="isNotSummary"/>
            <el-table-column label="课时费" align="center" prop="salary" type="money">
              <template v-slot="{ row }">
                {{ row.salary | toYuan }}
              </template>
            </el-table-column>
            <el-table-column label="绩效" align="center" prop="bonus" type="money">
              <template v-slot="{ row }">
                {{ row.bonus | toYuan }}
              </template>
            </el-table-column>
            <el-table-column label="实发" align="center" prop="actual_payment" type="money">
              <template v-slot="{ row }">
                {{ row.actual_payment | toYuan }}
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>
        <el-dialog
          title="工资条"
          :visible.sync="isShowPayslipDialog"
          width="25%"
          center>
          <div class="course-alert" ref="payslip">
            <template v-if="report.is_ladder_salary">
              <div v-if="adult_course_count" class="course-alert-item">
                成人班上课 {{ adult_course_count }} 小时<template v-if="adult_student_average">，平均人数 {{ adult_student_average }}</template>
              </div>
              <div v-if="adult_bonus" class="course-alert-item">
                奖金 {{ adult_bonus }}（
                <template v-for="(v, k) in adult_bonus_count">
                  {{ v.course_count }} 小时超过 {{ v.min_number }} 人 + {{ v.course_count }} x {{ v.bonus | toYuan }}
                  <template v-if="k !== adult_bonus_count.length - 1">，</template>
                </template>）
              </div>
              <div v-if="child_course_count" class="course-alert-item">
                少儿班上课 {{ child_course_count }} 小时<template v-if="child_student_average">，平均人数 {{ child_student_average }}</template>
              </div>
              <div v-if="child_bonus" class="course-alert-item">
                奖金 {{ child_bonus }}（
                <template v-for="(v, k) in child_bonus_count">
                  {{ v.course_count }} 小时超过 {{ v.min_number }} 人 + {{ v.course_count }} x {{ v.bonus | toYuan }}
                  <template v-if="k !== child_bonus_count.length - 1">，</template>
                </template>）
              </div>
              <div v-if="major_course_count" class="course-alert-item">
                专业班上课 {{ major_course_count }} 小时<template v-if="major_student_average">，平均人数 {{ major_student_average }}</template>
              </div>
              <div v-if="major_bonus" class="course-alert-item">
                奖金 {{ major_bonus }}（
                <template v-for="(v, k) in major_bonus_count">
                  {{ v.course_count }} 小时超过 {{ v.min_number }} 人 + {{ v.course_count }} x {{ v.bonus | toYuan }}
                  <template v-if="k !== major_bonus_count.length - 1">，</template>
                </template>）
              </div>
            </template>
            <template v-else>
              <div v-if="group_course_count" class="course-alert-item">
                大课 {{ group_course_count }} 小时<template v-if="group_student_average > 1">，平均人数 {{ group_student_average }}</template>
              </div>
            </template>

            <div v-if="private_course_count" class="course-alert-item">
              私教上课 {{ private_course_count }} 小时<template v-if="personal_student_average > 1">，平均人数 {{ personal_student_average }}</template>
            </div>
            <div v-if="base_pay" class="course-alert-item">
              底薪 {{ base_pay }}
            </div>
            <div v-if="social_insurance" class="course-alert-item">
              公司社保 {{ social_insurance }}
            </div>
            <div v-if="personal_insurance" class="course-alert-item">
              个人社保 {{ personal_insurance }}
            </div>
            <div v-if="absence_count" class="course-alert-item">
              旷课 {{ absence_count }} 小时
            </div>
            <div class="course-alert-item">
              合计
              <template v-if="report.is_ladder_salary">
                <template v-if="adult_course_count">
                  {{ adult_course_count }} × {{ adult_class_pay }}
                  <template v-if="adult_bonus">+ {{ adult_bonus }} </template>
                </template>
                <template v-if="child_course_count">
                  <template v-if="adult_course_count">+ </template>{{ child_course_count }} × {{ child_class_pay }}
                  <template v-if="child_bonus">+ {{ child_bonus }}</template>
                </template>
                <template v-if="major_course_count">
                  + {{ major_course_count }} × {{ major_class_pay }}
                  <template v-if="major_bonus">+ {{ major_bonus }}</template>
                </template>
              </template>
              <template v-else>
                <template v-if="group_course_count">
                  {{ group_course_count }} × {{ group_class_pay }}
                </template>
              </template>

              <template v-if="private_course_count">
                + {{ private_course_count }} × {{ private_class_pay }}
              </template>
              <template v-if="base_pay">
                + {{ base_pay }}
              </template>
              <template v-if="social_insurance">
                + {{ social_insurance }}
              </template>
              <template v-if="absence_count">
                - {{ absence_count }} × {{ leave_class_pay }}
              </template>
              = {{ all_pay }}
            </div>
            <div class="course-alert-item" v-if="actual_pay !== all_pay">
              实发 {{ all_pay }} - {{ social_insurance }} - {{ personal_insurance }} = {{ actual_pay }}
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShowPayslipDialog = false">返回</el-button>
            <el-button type="primary" @click="copyPayslip">复制</el-button>
          </span>
        </el-dialog>

        <el-table
          v-if="!isLoading && !isTeacherSalariesLoading"
          class="teacher-salary-table"
          :data="teacherSalaries"
          border
          fit
          highlight-current-row
          :show-summary="true"
          :summary-method="getTeacherSummaries"
          :height="teacherSalaries.length > 7 ? 699 : undefined"
        >
          <el-table-column label="老师" align="center" width="130">
            <template v-slot="{ row }">
              <v-avatar-nickname :value="row.avatar" :nickname="row.nickname"/>
            </template>
          </el-table-column>
          <el-table-column v-if="!report.is_ladder_salary" label="大课" width="190" align="center" prop="group_course_pay">
            <template v-slot="{ row }">
              <div class="flex-center">
                <template v-if="row.group_course_count">
                  {{ row.group_course_count }}
                  <span class="separator">×</span>
                  {{ row.class_pay }}
                  <span class="separator">=</span>
                  <b>{{ row.group_course_pay }}</b>
                </template>
                <template v-else>-</template>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="report.is_ladder_salary" label="成人班" width="190" align="center" prop="adult_course_pay">
            <template v-slot="{ row }">
              <div class="flex-center">
                <template v-if="row.adult_course_count">
                  {{ row.adult_course_count }}
                  <span class="separator">×</span>
                  {{ row.adult_class_pay }}
                  <span class="separator">=</span>
                  <b>{{ row.adult_course_pay }}</b>
                </template>
                <template v-else>-</template>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="report.is_ladder_salary" label="少儿班" width="190" align="center" prop="child_course_pay">
            <template v-slot="{ row }">
              <div class="flex-center">
                <template v-if="row.child_course_count">
                  {{ row.child_course_count }}
                  <span class="separator">×</span>
                  {{ row.child_class_pay }}
                  <span class="separator">=</span>
                  <b>{{ row.child_course_pay }}</b>
                </template>
                <template v-else>-</template>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="report.is_ladder_salary && report.is_has_major" label="专业班" width="190" align="center" prop="major_course_pay">
            <template v-slot="{ row }">
              <div class="flex-center">
                <template v-if="row.major_course_count">
                  {{ row.major_course_count }}
                  <span class="separator">×</span>
                  {{ row.major_class_pay }}
                  <span class="separator">=</span>
                  <b>{{ row.major_course_pay }}</b>
                </template>
                <template v-else>-</template>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="私教" align="center" width="190" prop="private_course_pay">
            <template v-slot="{ row }">
              <div class="flex-center">
                <template v-if="row.private_course_count">
                  {{ row.private_course_count }}
                  <span class="separator">×</span>
                  {{ row.private_class_pay }}
                  <span class="separator">=</span>
                  <b>{{ row.private_course_pay }}</b>
                </template>
                <template v-else>-</template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="旷课" align="center" width="190" prop="absence_pay">
            <template v-slot="{ row }">
              <div class="flex-center">
                <template v-if="row.absence_count">
                  {{ row.absence_count }}
                  <span class="separator">×</span>
                  {{ row.leave_class_pay }}
                  <span class="separator">=</span>
                  <b>{{ row.absence_pay }}</b>
                </template>
                <template v-else>-</template>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="底薪" align="center" width="76" prop="base_pay">
            <template v-slot="{ row }">
              {{ row.base_pay ? row.base_pay : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="公司社保" align="center" width="76" prop="social_insurance">
            <template v-slot="{ row }">
              {{ row.social_insurance ? row.social_insurance : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="门店社保" align="center" width="76" prop="store_insurance">
            <template v-slot="{ row }">
              {{ row.store_insurance ? row.store_insurance : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="个人社保" align="center" width="76" prop="personal_insurance">
            <template v-slot="{ row }">
              {{ row.personal_insurance ? row.personal_insurance : '-' }}
            </template>
          </el-table-column>
          <el-table-column v-if="report.is_ladder_salary" label="绩效" width="76" align="center" prop="bonus">
            <template v-slot="{ row }">
              {{ row.bonus ? row.bonus : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="实发" align="center" width="76" prop="actual_pay">
            <template v-slot="{ row }">
              {{ row.actual_pay }}
            </template>
          </el-table-column>
          <el-table-column label="合计" align="center" width="76" prop="all_pay">
            <template v-slot="{ row }">
              <span class="success-color">{{ row.all_pay }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template v-slot="{ $index, row }">
              <el-button class="table-button" size="mini" type="primary" :loading="isCourseLoading" @click="getTeacherCourses(row)">详情</el-button>
              <el-button class="table-button" size="mini" type="success" :loading="isCourseLoading" @click="showPayslip(row)">工资条</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="table-box">
        <h3>店员工资统计</h3>
        <el-table
          :data="staffSalaries"
          class="income-table"
          border
          fit
          highlight-current-row
          :show-summary="true"
          :summary-method="getStaffSummaries"
          :height="staffSalaries.length > 7 ? 699 : undefined"
        >
          <el-table-column label="员工" align="center" width="154">
            <template v-slot="{ row }">
              <v-avatar-nickname :value="row.avatar" :nickname="row.nickname"/>
            </template>
          </el-table-column>
          <el-table-column label="底薪" align="center" prop="base_pay" width="130">
            <template v-slot="{ row }">{{ row.base_pay ? row.base_pay : '-' }}</template>
          </el-table-column>
          <el-table-column label="业绩任务" align="center" width="130">
            <template v-slot="{ row }">{{ row.task_income ? row.task_income : '-' }}</template>
          </el-table-column>

          <el-table-column label="未完成底薪比例" align="center" width="140">
            <template v-slot="{ row }">
              {{ row.base_pay_rate ? `${row.base_pay_rate} %` : '-' }}
            </template>
          </el-table-column>

          <el-table-column label="完成后提成比例" align="center" width="140">
            <template v-slot="{ row }">
              {{ row.commission_rate ? `${row.commission_rate} %` : '-' }}
            </template>
          </el-table-column>

          <el-table-column label="实发底薪" align="center" prop="actual_base_pay" width="130">
            <template v-slot="{ row }">
              {{ row.actual_base_pay ? row.actual_base_pay : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="提成" align="center" prop="percentage_pay" width="130">
            <template v-slot="{ row }">
              {{ row.commission ? row.commission : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="公司社保" align="center" prop="social_insurance" width="130">
            <template v-slot="{ row }">
              {{ row.social_insurance ? row.social_insurance : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="门店社保" align="center" prop="store_insurance" width="130">
            <template v-slot="{ row }">
              {{ row.store_insurance ? row.store_insurance : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="个人社保" align="center" prop="personal_insurance" width="130">
            <template v-slot="{ row }">
              {{ row.personal_insurance ? row.personal_insurance : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="奖金" align="center" prop="bonus" width="130">
            <template v-slot="{ row }">
              {{ row.bonus ? row.bonus : '-' }}
            </template>
          </el-table-column>
          <el-table-column label="实发" align="center" prop="actual_pay">
            <template v-slot="{ row }">
              {{ row.actual_pay }}
            </template>
          </el-table-column>
          <el-table-column label="总计" align="center" prop="all_pay">
            <template v-slot="{ row }">
              <span class="success-color">{{ row.all_pay }}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-alert
          class="income-table add-button"
          type="info"
          show-icon
          :closable="false"
        >
          <div class="performance-summary-item">
            本月业绩收入：新生 {{ staffPerformanceSummary.new_income }} 元 + 老生 {{ staffPerformanceSummary.old_income }} 元 + 小程序预约(不含退款) {{ staffPerformanceSummary.reservationIncome }} 元 + 课次券 {{ staffPerformanceSummary.cardTicketIncome }} 元 + 代金券 {{ staffPerformanceSummary.voucherIncome }} 元 = 合计 <b>{{ staffPerformanceSummary.totalIncome }}</b> 元
          </div>
          <div
            v-for="item in staffPerformanceSummary.items"
            :key="item.name"
            class="performance-summary-item"
            :class="item.isMet ? 'success-color' : 'danger-color'"
          >
            {{ item.name }}：完成 {{ item.percentage }}%（{{ item.isMet ? `超出 ${item.diff}` : `差 ${-item.diff}` }} 元）{{ item.isMet ? '已完成' : '未达标' }}，提成：{{ item.isMet && item.commissionRate ? `${item.diff} × ${item.commissionRate}% = ${item.commission}` : '0 元' }}
          </div>
        </el-alert>
      </div>

      <div class="table-box">
        <h3>支出统计</h3>
        <el-form-item label="老师工资">
          <span class="success-color money">{{ report.teacher_pay }}</span> 元
        </el-form-item>
        <el-form-item label="店员工资">
          <span class="success-color money">{{ report.staff_pay }}</span> 元
        </el-form-item>
        <el-form-item label="保洁工资">
          <span class="success-color money">{{ report.cleaner_pay }}</span> 元
        </el-form-item>
        <el-form-item label="房租费用">
          <span class="success-color money">{{ report.house_pay }}</span> 元
        </el-form-item>
        <el-form-item label="广告费用">
          <span class="success-color money">{{ report.advert_pay }}</span> 元
        </el-form-item>
        <el-form-item label="订购饮料费用">
          <span class="success-color money">{{ report.drink_pay }}</span> 元
        </el-form-item>
        <el-form-item label="水电宽带电话费用">
          <span class="success-color money">{{ report.water_pay }}</span> 元
        </el-form-item>
        <el-form-item label="发票税额">
          <span class="success-color money">{{ report.tax_amount_pay }}</span> 元
        </el-form-item>
        <el-form-item label="退卡支出">
          <span class="success-color money">{{ report.refund_pay }}</span> 元
        </el-form-item>
        <el-form-item label="券退款支出（需转总部）">
          <span class="success-color money">{{ report.ticket_refund_pay }}</span> 元
        </el-form-item>
        <el-form-item label="券退款笔数">
          <span class="success-color money">{{ report.ticket_refund_count }}</span> 笔
        </el-form-item>
        <el-form-item label="修改课卡补差价支出">
          <span class="success-color money">{{ report.update_pay }}</span> 元
        </el-form-item>
        <el-form-item label="小程序预约退款支出">
          <span class="success-color money">{{ report.reservation_pay }}</span> 元
        </el-form-item>
        <el-form-item label="其他支出">
          <span class="success-color money">{{ report.other_pay }}</span> 元
        </el-form-item>
        <el-form-item label="其他支出备注">{{ report.other_pay_remark || '-' }}</el-form-item>
      </div>

      <div class="table-box">
        <div class="profit-box">
          <h3 class="profit-title">总收入</h3>
          <h2 class="danger-color">{{ report.all_income }}</h2>
        </div>
        <div class="profit-box">
          <h3 class="profit-title">总支出</h3>
          <h2 class="success-color">{{ report.expenditure }}</h2>
        </div>
        <div class="profit-box">
          <h3 class="profit-title">总利润</h3>
          <h2 :class="`${report.profit >= 0 ? 'danger' : 'success'}-color`">
            {{ report.profit }}
          </h2>
        </div>

        <template v-if="report.store_revenue_sharing || report.revenue_sharing">
          <div class="profit-box">
            <h3 class="profit-title">总部提成百分比</h3>
            <h2 class="success-color">{{ report.revenue_sharing }} %</h2>
          </div>
          <div class="profit-box">
            <h3 class="profit-title">总部提成</h3>
            <h2 class="success-color">{{ report.commission }}</h2>
          </div>
          <el-alert
            v-if="+report.defaultCommission !== +report.commission"
            :title="`当前提成数额与系统计算数额「${report.defaultCommission}」不相符！`"
            class="commission-tip"
            type="info"
            effect="dark"
            show-icon
            :closable="false"
          />
          <div class="profit-box">
            <h3 class="profit-title">最终盈利</h3>
            <h2 :class="`${report.net_profit >= 0 ? 'danger' : 'success'}-color`">
              {{ report.net_profit }}
            </h2>
          </div>
        </template>
      </div>

      <el-button @click="RouteConfig.monthlyReportList.back">返回</el-button>
    </el-form>
  </section>
</template>

<script>
  import RouteConfig from '@/router/config';
  import copyToClipboard from "@/utils/clipboard";
  import { mapGetters } from 'vuex';
  import { findPaymentModeName } from "@/enums/paymentModes";
  import { findCourseState } from '@/enums/courseStates';
  import { getTableSummaries } from '@/utils/number';
  import { getSummaries } from "@/utils/getSummary";
  import { getReservationIncomes, getReservationPays, getUpdatePayments } from '@/api/daily-report';
  import {
    plus,
    multipliedBy,
    dividedBy,
    toYuan,
    toSecond,
    toMillisecond,
    minus,
    decimalPlaces,
  } from '@/filters';
  import {
    show,
    getStaffSalariesByReportId,
    getTeacherSalariesByReportId,
    getCards, getTeacherCourses, getInvoices
  } from '@/api/monthly-report';

  export default {
    name: RouteConfig.monthlyReportDetail.name,
    data: () => ({
      RouteConfig,
      isLoading: false,
      isCardsLoading: false,
      // 「详情」与「工资条」都会拉老师排课，共用一个 loading 防止连点重复请求
      isCourseLoading: false,
      isShowCourseDialog: false,
      isShowPayslipDialog: false,
      isLoadingError: false,
      isCardsLoadingError: false,
      isTeacherSalariesLoading: false,
      isSaving: false,
      isFirstGetData: true,

      isShowNewCards: false,
      isShowOldCards: false,
      isShowDelCards: false,
      isShowOtherIncomes: false,
      isShowUpdateIncomes: false,
      isShowUpdatePays: false,
      isShowReservationIncomes: false,
      isShowReservationPays: false,
      isShowInvoices: false,

      cardListPageSize: 8,
      trailPaymentsPageSize: 8,
      totalTeacherInsurance: 0,
      totalStaffInsurance: 0,
      courseCount: 0,
      stores: [],
      teacherSalaries: [],
      staffSalaries: [],
      youZanIncomes: [],
      teachers: [],
      newCards: [],
      oldCards: [],
      delCards: [],
      invoices: [],
      otherIncomes: [],
      updateIncomes: [],
      reservationIncomes: [],
      reservationPays: [],
      updatePays: [],
      courses: [],
      pickerOptions: {
        disabledDate: (time) => time.getTime() >= Date.now(),
      },

      social_insurance: 0,
      personal_insurance: 0,
      bonus: 0,

      adult_bonus: 0,
      child_bonus: 0,
      major_bonus: 0,

      group_course_count: 0,
      adult_course_count: 0,
      child_course_count: 0,
      major_course_count: 0,
      private_course_count: 0,
      absence_count: 0,
      new_cards_del_count: 0,
      old_cards_del_count: 0,
      reservation_income_del_count: 0,

      base_pay: 0,
      all_pay: 0,
      actual_pay: 0,
      group_class_pay: 0,
      adult_class_pay: 0,
      child_class_pay: 0,
      major_class_pay: 0,
      private_class_pay: 0,
      leave_class_pay: 0,

      adult_bonus_count: [],
      child_bonus_count: [],
      major_bonus_count: [],

      adult_course_leave_count: 0,
      child_course_leave_count: 0,
      major_course_leave_count: 0,
      personal_course_leave_count: 0,

      group_student_average: 0,
      adult_student_average: 0,
      child_student_average: 0,
      major_student_average: 0,
      personal_student_average: 0,

      report: {
        add_time: '',
        store_id: '',
        store_name: '',
        report_date: '',

        new_income: 0,
        old_income: 0,
        trial_income: 0,
        card_ticket_income: 0,
        voucher_income: 0,
        update_income: 0,
        reservation_income: 0,
        reservation_income_valid: 0,
        other_income: 0,
        other_income_remark: '',

        we_chat_income: 0,
        alipay_income: 0,
        fu_zhang_gui_income: 0,
        meituan_income: 0,
        card_income: 0,
        cash_income: 0,
        you_zan_income: 0,
        dou_yin_income: 0,
        transfer_income: 0,
        applet_income: 0,

        all_income: 0,
        all_income_way: 0,
        task_income: 0,
        new_count: 0,
        old_count: 0,
        trial_count: 0,
        card_ticket_income_count: 0,
        voucher_income_count: 0,
        ticket_refund_pay: 0,
        ticket_refund_count: 0,
        invoice_count: 0,
        update_income_count: 0,
        update_pay_count: 0,
        reservation_income_count: 0,
        reservation_pay_count: 0,
        other_count: 0,
        average_attendance: 0,
        course_consumption: 0,
        not_consumed_amount: 0,

        teacher_pay: 0,
        staff_pay: 0,
        house_pay: 0,
        advert_pay: 0,
        cleaner_pay: 0,
        drink_pay: 0,
        water_pay: 0,
        tax_amount_pay: 0,
        refund_pay: 0,
        update_pay: 0,
        reservation_pay: 0,
        other_pay: 0,
        other_pay_remark: '',
        expenditure: 0,

        profit: 0,
        revenue_sharing: 0,
        commission: 0,
        net_profit: 0,

        is_ladder_salary: 0,
        is_has_major: 0,
        store_revenue_sharing: 0,

        last_month_income_is_zero: 0,
        last_month_income_trend_percent: 0,
        last_month_income_absolute_increase: 0,
        last_month_student_trend: 0,
        last_month_profit_is_zero: 0,
        last_month_profit_trend_percent: 0,
        last_month_profit_absolute_increase: 0,

        last_year_income_is_zero: 0,
        last_year_income_trend_percent: 0,
        last_year_income_absolute_increase: 0,
        last_year_student_trend: 0,
        last_year_profit_is_zero: 0,
        last_year_profit_trend_percent: 0,
        last_year_profit_absolute_increase: 0,
        defaultCommission: 0,
      },
    }),
    computed: {
      ...mapGetters([
        'isAdministrator',
      ]),
      id() {
        return +this.$route.params.id || 0;
      },
      totalInsurance() {
        return plus(this.totalTeacherInsurance, this.totalStaffInsurance);
      },
      totalInsuranceAndTax() {
        return plus(this.totalInsurance, this.report.tax_amount_pay);
      },
      youZanIncomeToStore() {
        return decimalPlaces(multipliedBy(this.report.you_zan_income, .99));
      },
      // 店员工资表格下方的业绩完成度汇总
      staffPerformanceSummary() {
        const { new_income, old_income, reservation_income_valid, card_ticket_income, voucher_income } = this.report;
        const reservationIncome = reservation_income_valid || 0;
        const cardTicketIncome = card_ticket_income || 0;
        const voucherIncome = voucher_income || 0;
        const totalIncome = plus(new_income, old_income, reservationIncome, cardTicketIncome, voucherIncome);
        const items = this.staffSalaries
          .filter(v => v.task_income)
          .map(v => {
            const taskIncome = v.task_income;
            const percentage = decimalPlaces(multipliedBy(dividedBy(totalIncome, taskIncome), 100), 1);
            const diff = decimalPlaces(minus(totalIncome, taskIncome));
            const commissionRate = v.commission_rate || 0;
            const commission = diff > 0 && commissionRate
              ? decimalPlaces(multipliedBy(diff, toYuan(commissionRate)))
              : 0;
            return {
              name: v.nickname || v.administrator_id,
              percentage,
              diff,
              isMet: totalIncome >= taskIncome,
              commissionRate,
              commission,
            };
          });

        return { new_income, old_income, reservationIncome, cardTicketIncome, voucherIncome, totalIncome, items };
      },
    },
    beforeMount() {
      this.load();
    },
    methods: {
      getTableSummaries,
      findCourseState,
      plus,
      findPaymentModeName,
      tableRowClassName({ row }) {
        return row.is_del ? 'warning-background' : '';
      },
      reservationIncomeTableRowClassName({ row }) {
        return row.is_refund ? 'warning-background' : '';
      },
      computeCommission() {
        const { report } = this;
        let { new_income, old_income, profit, revenue_sharing, is_generic } = report;

        if (!revenue_sharing) return;
        if (is_generic) return this.computeCommissionForGenericStore();
        const all_income = plus(new_income, old_income);

        let commission = 0;
        if (profit > 0) {// 盈利时，总部抽成 = 总收入 * 抽成比例
          let maxCommission = multipliedBy(profit, 0.4);

          commission = multipliedBy(all_income, toYuan(revenue_sharing));
          commission = Math.min(commission, maxCommission);
        } else {
          commission = multipliedBy(all_income, 0.06);
        }

        commission = decimalPlaces(commission);

        Object.assign(report, {
          defaultCommission: commission,
        });
      },
      computeCommissionForGenericStore() {
        const { report } = this;
        let { new_income, old_income, house_pay, teacher_pay, staff_pay, revenue_sharing } = report;
        const all_income = plus(new_income, old_income);
        const grossProfit = minus(all_income, house_pay, teacher_pay, staff_pay);

        let commission = 0;
        if (grossProfit <= 0) {
          commission = 1000;
        } else {
          let maxCommission = multipliedBy(grossProfit, 0.2);
          commission = multipliedBy(all_income, toYuan(revenue_sharing));
          commission = Math.min(commission, maxCommission);
          commission = Math.max(commission, 1000);
          commission = decimalPlaces(commission);
        }

        Object.assign(report, {
          defaultCommission: commission,
        });
      },

      getYearAndMonth(timestamp) {
        if (!timestamp) return '';

        const date = new Date(timestamp);
        const month = date.getMonth() + 1;
        return `${date.getFullYear()} 年 ${month} 月`;
      },
      async load() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.isLoadingError = false;

        await Promise.all([
          this.show(),
          this.getTeacherSalaries(),
          this.getStaffSalaries(),
        ]);

        this.isLoading = false;
      },
      getTeacherSummaries(param) {
        return getSummaries({
          param,
          report: this.report,
          allPayField: 'teacher_pay',
        });
      },
      getStaffSummaries(param) {
        return getSummaries({
          param,
          report: this.report,
          allPayField: 'staff_pay',
        });
      },
      async show() {
        const { isError, data } = await show(this.id);

        if (isError) {
          this.isLoadingError = true;
          return;
        }

        Object.assign(this, {
          youZanIncomes: data.you_zan_incomes || [],
          report: {
            add_time: data.add_time,
            store_id: data.store_id,
            store_name: data.store_name,
            report_date: toMillisecond(data.report_date),

            new_income: toYuan(data.new_income),
            old_income: toYuan(data.old_income),
            trial_income: toYuan(data.trial_income),
            card_ticket_income: toYuan(data.card_ticket_income),
            voucher_income: toYuan(data.voucher_income),
            voucher_income_count: data.voucher_income_count || 0,
            ticket_refund_pay: toYuan(data.ticket_refund_pay),
            ticket_refund_count: data.ticket_refund_count || 0,
            update_income: toYuan(data.update_income),
            reservation_income: toYuan(data.reservation_income),
            reservation_income_valid: toYuan(data.reservation_income_valid || 0),
            other_income: toYuan(data.other_income),
            other_income_remark: data.other_income_remark || '',

            we_chat_income: toYuan(data.we_chat_income),
            alipay_income: toYuan(data.alipay_income),
            fu_zhang_gui_income: toYuan(data.fu_zhang_gui_income),
            meituan_income: toYuan(data.meituan_income),
            card_income: toYuan(data.card_income),
            cash_income: toYuan(data.cash_income),
            you_zan_income: toYuan(data.you_zan_income),
            dou_yin_income: toYuan(data.dou_yin_income),
            transfer_income: toYuan(data.transfer_income),
            applet_income: toYuan(data.applet_income),

            all_income: toYuan(data.all_income),
            all_income_way: toYuan(data.all_income),
            expenditure: toYuan(data.expenditure),

            new_count: data.new_count || 0,
            old_count: data.old_count || 0,
            trial_count: data.trial_count || 0,
            card_ticket_income_count: data.card_ticket_income_count || 0,
            invoice_count: data.invoice_count || 0,
            update_income_count: data.update_income_count || 0,
            update_pay_count: data.update_pay_count || 0,
            reservation_income_count: data.reservation_income_count || 0,
            reservation_pay_count: data.reservation_pay_count || 0,
            other_count: data.other_count || 0,
            group_course_count: toYuan(data.group_course_count),
            private_course_count: toYuan(data.private_course_count),
            adult_course_count: toYuan(data.adult_course_count),
            child_course_count: toYuan(data.child_course_count),
            major_course_count: toYuan(data.major_course_count),
            late_count: toYuan(data.late_count),
            absence_count: toYuan(data.absence_count),
            // total_attendance 存储值为实际值×100，展示时需 toYuan（÷100）
            total_attendance: data.total_attendance || 0,

            average_attendance: data.average_attendance || 0,
            course_consumption: data.course_consumption || 0,
            not_consumed_amount: data.not_consumed_amount || 0,
            revenue_sharing: toYuan(data.revenue_sharing),

            teacher_pay: toYuan(data.teacher_pay),
            staff_pay: toYuan(data.staff_pay),
            house_pay: toYuan(data.house_pay),
            advert_pay: toYuan(data.advert_pay),
            cleaner_pay: toYuan(data.cleaner_pay),
            drink_pay: toYuan(data.drink_pay),
            water_pay: toYuan(data.water_pay),
            tax_amount_pay: toYuan(data.tax_amount_pay),
            refund_pay: toYuan(data.refund_pay),
            update_pay: toYuan(data.update_pay),
            reservation_pay: toYuan(data.reservation_pay),
            other_pay: toYuan(data.other_pay),
            other_pay_remark: data.other_pay_remark || '',

            profit: toYuan(data.profit),
            commission: toYuan(data.commission),
            defaultCommission: toYuan(data.commission),
            net_profit: toYuan(data.net_profit),

            is_ladder_salary: data.is_ladder_salary,
            is_has_major: data.is_has_major,
            store_revenue_sharing: data.store_revenue_sharing,

            last_month_income_is_zero: data.last_month_income_is_zero ? 1 : 0,
            last_month_income_trend_percent: toYuan(data.last_month_income_trend_percent),
            last_month_income_absolute_increase: toYuan(data.last_month_income_absolute_increase),
            last_month_student_trend: data.last_month_student_trend || 0,
            last_month_profit_is_zero: data.last_month_profit_is_zero ? 1 : 0,
            last_month_profit_trend_percent: toYuan(data.last_month_profit_trend_percent),
            last_month_profit_absolute_increase: toYuan(data.last_month_profit_absolute_increase),

            last_year_income_is_zero: data.last_year_income_is_zero ? 1 : 0,
            last_year_income_trend_percent: toYuan(data.last_year_income_trend_percent),
            last_year_income_absolute_increase: toYuan(data.last_year_income_absolute_increase),
            last_year_student_trend: data.last_year_student_trend || 0,
            last_year_profit_is_zero: data.last_year_profit_is_zero ? 1 : 0,
            last_year_profit_trend_percent: toYuan(data.last_year_profit_trend_percent),
            last_year_profit_absolute_increase: toYuan(data.last_year_profit_absolute_increase),
            is_generic: !!data.is_generic,
          },
        });

        this.getCards();
        this.getInvoices();
        this.getUpdatePayments(1);
        this.getUpdatePayments(0);
        this.getReservationIncomes();
        this.getReservationPays();
        this.computeCommission();
      },
      async getCards() {
        const { isError, data } = await getCards({
          store_id: this.report.store_id,
          report_date: toSecond(this.report.report_date),
        });

        if (isError) {
          this.isCardsLoadingError = true;
          return;
        }

        this.newCards = data.new_cards || [];
        this.oldCards = data.old_cards || [];
        this.delCards = data.del_cards || [];
        this.otherIncomes = data.other_incomes || [];
        this.new_cards_del_count = data.new_cards_del_count || 0;
        this.old_cards_del_count = data.old_cards_del_count || 0;
        if (this.newCards.length < 11) this.isShowNewCards = true;
        if (this.oldCards.length < 11) this.isShowOldCards = true;
        if (this.delCards.length < 11) this.isShowDelCards = true;
        if (this.otherIncomes.length < 11) this.isShowOtherIncomes = true;
      },
      async getInvoices() {
        const { isError, data } = await getInvoices({
          store_id: this.report.store_id,
          report_date: toSecond(this.report.report_date),
        });

        if (isError || !data) {
          this.isCardsLoadingError = true;
          return;
        }

        this.invoices = data;
        this.report.invoice_count = data.length;
        let taxAmount = 0;
        for (let i = 0; i < data.length; i++) {
          taxAmount = plus(taxAmount, data[i].tax_amount);
        }
        this.report.tax_amount_pay = toYuan(taxAmount);
        if (this.report.invoice_count < 11) this.isShowInvoices = true;
      },
      async getUpdatePayments(is_income) {
        const { isError, data } = await getUpdatePayments({
          store_id: this.report.store_id,
          report_date: toSecond(this.report.report_date),
          is_monthly: 1,
          is_income,
        });

        if (isError) return;

        if (is_income) {
          this.updateIncomes = data.list || [];
        } else {
          this.updatePays = data.list || [];
        }
        if (this.updateIncomes.length < 11) this.isShowUpdateIncomes = true;
        if (this.updatePays.length < 11) this.isShowUpdatePays = true;
      },
      async getReservationIncomes() {
        const { isError, data } = await getReservationIncomes({
          store_id: this.report.store_id,
          report_date: toSecond(this.report.report_date),
          is_monthly: 1,
        });

        if (isError) {
          this.isCardsLoadingError = true;
          return;
        }

        this.report.reservation_income_count = data.count || 0;
        this.reservation_income_del_count = data.reservation_income_del_count || 0;
        this.reservationIncomes = data.list || [];
        this.isShowReservationIncomes = this.reservationIncomes.length < 11;
      },
      async getReservationPays() {
        const { isError, data } = await getReservationPays({
          store_id: this.report.store_id,
          report_date: toSecond(this.report.report_date),
          is_monthly: 1,
        });

        if (isError) {
          this.isCardsLoadingError = true;
          return;
        }

        this.report.reservation_pay_count = data.count || 0;
        this.reservationPays = data.list || [];
        this.isShowReservationPays = this.reservationPays.length < 11;
      },
      async getTeacherSalaries() {
        if (this.isTeacherSalariesLoading) return;

        this.isTeacherSalariesLoading = true;
        const { isError, data } = await getTeacherSalariesByReportId(this.id, 1);
        this.isTeacherSalariesLoading = false;

        if (isError) {
          this.isLoadingError = true;
          return;
        }

        let totalTeacherInsurance = 0;
        data.forEach(v => {
          totalTeacherInsurance += v.social_insurance + v.personal_insurance;

          v.base_pay = toYuan(v.base_pay);
          v.social_insurance = toYuan(v.social_insurance);
          v.store_insurance = toYuan(v.store_insurance);
          v.personal_insurance = toYuan(v.personal_insurance);
          v.class_pay = toYuan(v.class_pay);
          v.private_class_pay = toYuan(v.private_class_pay);
          v.leave_class_pay = toYuan(v.leave_class_pay);

          v.adult_course_pay = toYuan(v.adult_course_pay);
          v.child_course_pay = toYuan(v.child_course_pay);
          v.major_course_pay = toYuan(v.major_course_pay);
          v.group_course_pay = toYuan(v.group_course_pay);
          v.private_course_pay = toYuan(v.private_course_pay);
          v.absence_pay = toYuan(v.absence_pay);
          v.adult_class_pay = toYuan(v.adult_class_pay);
          v.child_class_pay = toYuan(v.child_class_pay);
          v.major_class_pay = toYuan(v.major_class_pay);
          v.bonus = toYuan(v.bonus);
          v.actual_pay = toYuan(v.actual_pay);
          v.all_pay = toYuan(v.all_pay);

          // 课时数字段存储为小时×100，前端回显需转为小时
          v.group_course_count = toYuan(v.group_course_count);
          v.private_course_count = toYuan(v.private_course_count);
          v.late_count = toYuan(v.late_count);
          v.absence_count = toYuan(v.absence_count);
          v.adult_course_count = toYuan(v.adult_course_count);
          v.child_course_count = toYuan(v.child_course_count);
          v.major_course_count = toYuan(v.major_course_count);
        });

        this.teacherSalaries = data;
        this.totalTeacherInsurance = toYuan(totalTeacherInsurance);
      },
      async getStaffSalaries() {
        const {isError, data} = await getStaffSalariesByReportId(this.id, 1);

        if (isError) {
          this.isLoadingError = true;
          return;
        }

        let totalStaffInsurance = 0;
        data.forEach(v => {
          totalStaffInsurance += v.social_insurance + v.personal_insurance;

          v.base_pay = toYuan(v.base_pay);
          v.task_income = toYuan(v.task_income);
          v.commission_rate = toYuan(v.commission_rate);
          v.base_pay_rate = toYuan(v.base_pay_rate);
          v.actual_base_pay = toYuan(v.actual_base_pay);
          v.commission = toYuan(v.commission);
          v.social_insurance = toYuan(v.social_insurance);
          v.store_insurance = toYuan(v.store_insurance);
          v.personal_insurance = toYuan(v.personal_insurance);
          v.bonus = toYuan(v.bonus);
          v.actual_pay = toYuan(v.actual_pay);
          v.all_pay = toYuan(v.all_pay);
        });

        this.staffSalaries = data;
        this.totalStaffInsurance = toYuan(totalStaffInsurance);
      },
      async getTeacherCourses(row) {
        if (this.isCourseLoading) return;

        this.isCourseLoading = true;
        this.isShowCourseDialog = true;
        this.courses = [];

        const { isError, data } = await getTeacherCourses({
          teacher_id: row.teacher_id,
          store_id: this.report.store_id,
          report_date: toSecond(this.report.report_date),
        });

        if (isError || !data || !data.courses || !data.courses.length) {
          this.isCourseLoading = false;
          return;
        }

        data.courses.forEach(v => {
          v.duration = Math.round((v.end_time - v.start_time) / 36);
        });
        this.courses = data.courses;
        this.isCourseLoading = false;
      },
      async showPayslip(row) {
        if (this.isCourseLoading) return;

        this.isCourseLoading = true;
        this.isShowPayslipDialog = true;

        this.base_pay = row.base_pay;
        this.all_pay = row.all_pay;
        this.actual_pay = row.actual_pay;
        this.social_insurance = row.social_insurance;
        this.personal_insurance = row.personal_insurance;
        this.bonus = row.bonus;

        this.group_course_count = row.group_course_count;
        this.adult_course_count = row.adult_course_count;
        this.child_course_count = row.child_course_count;
        this.major_course_count = row.major_course_count;
        this.private_course_count = row.private_course_count;
        this.absence_count = row.absence_count;

        this.adult_course_leave_count = 0;
        this.child_course_leave_count = 0;
        this.major_course_leave_count = 0;
        this.personal_course_leave_count = 0;

        this.group_class_pay = row.class_pay;
        this.adult_class_pay = row.adult_class_pay;
        this.child_class_pay = row.child_class_pay;
        this.major_class_pay = row.major_class_pay;
        this.private_class_pay = row.private_class_pay;
        this.leave_class_pay = row.leave_class_pay;

        this.adult_bonus = row.adult_bonus;
        this.child_bonus = row.child_bonus;
        this.major_bonus = row.major_bonus;

        this.adult_bonus_count = [];
        this.child_bonus_count = [];
        this.major_bonus_count = [];

        this.adult_student_average = 0;
        this.child_student_average = 0;
        this.major_student_average = 0;
        this.personal_student_average = 0;

        const { isError, data } = await getTeacherCourses({
          teacher_id: row.teacher_id,
          store_id: this.report.store_id,
          report_date: toSecond(this.report.report_date),
        });

        if (isError || !data || !data.courses || !data.courses.length) {
          this.isCourseLoading = false;
          return;
        }

        this.adult_bonus_count = data.adult_bonus_count.length ? data.adult_bonus_count : [];
        this.child_bonus_count = data.child_bonus_count.length ? data.child_bonus_count : [];
        this.major_bonus_count = data.major_bonus_count.length ? data.major_bonus_count : [];

        this.adult_course_leave_count = data.adult_course_leave_count || 0;
        this.child_course_leave_count = data.child_course_leave_count || 0;
        this.major_course_leave_count = data.major_course_leave_count || 0;
        this.personal_course_leave_count = data.personal_course_leave_count || 0;
        this.adult_bonus = toYuan(data.adult_bonus);
        this.child_bonus = toYuan(data.child_bonus);
        this.major_bonus = toYuan(data.major_bonus);
        this.group_student_average = data.group_student_average || 0;
        this.adult_student_average = data.adult_student_average || 0;
        this.child_student_average = data.child_student_average || 0;
        this.major_student_average = data.major_student_average || 0;
        this.personal_student_average = data.personal_student_average || 0;
        this.isCourseLoading = false;
      },
      copyPayslip() {
        copyToClipboard({ element: this.$refs.payslip });
      },
    },
  };
</script>

<style src="./add.css" lang="css" scoped/>
